<template>
  <div class="sickdaystatistics__report__view">
    <div class="reports__subheader">
      <period-panel
        :dateFrom="dateFrom"
        :dateTo="dateTo"
        @dateFrom="(value) => (this.dateFrom = value)"
        @dateTo="(value) => (this.dateTo = value)"
      >
      </period-panel>

      <group-panel @groupId="(value) => (groupId = value)" :addDefault="true">
      </group-panel>

      <submit-panel @submit="performLookup"> </submit-panel>

      <div class="reports__panel--submit" v-if="filteredData.length > 0">
        <b-button class="button is-primary" @click="openSidebarAsync()">
          Filtrere medarbejdere
        </b-button>
      </div>
    </div>

    <b-table
      :data="filteredData"
      :loading="loading"
      default-sort="number"
      hoverable
    >
      <b-table-column
        field="number"
        label="Ins. nr."
        v-slot="props"
        sortable
        numeric
      >
        {{ props.row.number }}
      </b-table-column>

      <b-table-column field="name" label="Inseminør" v-slot="props" sortable>
        {{ props.row.name }}
      </b-table-column>

      <b-table-column
        field="primo"
        label="Primo"
        v-slot="props"
        numeric
        cell-class="cell-note"
        sortable
      >
        {{ props.row.primo | twodecimal }}
      </b-table-column>

      <b-table-column
        field="usage"
        label="Brugt"
        v-slot="props"
        numeric
        cell-class="cell-note"
        sortable
      >
        {{ props.row.usage | twodecimal }}
      </b-table-column>

      <b-table-column
        field="accumulated"
        label="Optjent"
        v-slot="props"
        numeric
        cell-class="cell-note"
        sortable
      >
        {{ props.row.accumulated | twodecimal }}
      </b-table-column>

      <b-table-column
        field="ultimo"
        label="Ultimo"
        v-slot="props"
        numeric
        cell-class="cell-note"
        sortable
      >
        {{ props.row.ultimo | twodecimal }}
      </b-table-column>

      <b-table-column
        field="vacationPrimo"
        label="Ferie Primo"
        v-slot="props"
        numeric
        sortable
      >
        {{ props.row.vacationPrimo | twodecimal }}
      </b-table-column>

      <b-table-column
        field="vacationUsage"
        label="Ferie Brugt"
        v-slot="props"
        numeric
        sortable
      >
        {{ props.row.vacationUsage | twodecimal }}
      </b-table-column>

      <b-table-column
        field="vacationUltimo"
        label="Ferie Ultimo"
        v-slot="props"
        numeric
        sortable
      >
        {{ props.row.vacationUltimo | twodecimal }}
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import APISTATE from "@/enums/APISTATE";
import PeriodPanel from "@/components/report/PeriodPanel.vue";
import GroupPanel from "@/components/report/GroupPanel.vue";
import SubmitPanel from "@/components/report/SubmitPanel.vue";

export default {
  name: "timeoff-report-view",
  components: { PeriodPanel, SubmitPanel, GroupPanel },
  data: () => ({
    dateFrom: undefined,
    dateTo: undefined,
    groupId: undefined,
  }),
  async mounted() {
    this.dateFrom = new Date(new Date().getFullYear(), 0, 1);
    this.dateTo = new Date(new Date().getFullYear(), 11, 31);
  },
  methods: {
    ...mapActions("reportStore", [
      "getTimeOffForPeriod",
      "setTimeOffForPeriod",
    ]),
    ...mapActions("generalStatisticsFilteringSidebar", [
      "sidebarOpenAsync",
      "setIsOpen",
      "setGroupMembers",
      "setFilter",
    ]),
    async performLookup() {
      const dto = {
        startDate: this.dateFrom,
        endDate: this.dateTo,
        forGroup: this.groupId,
      };
      await this.getTimeOffForPeriod(dto);
    },
    async openSidebarAsync() {
      this.setGroupMembers(this.filteredData);
      await this.sidebarOpenAsync()
        .then(async (response) => {
          if (response.action === "update") {
            await this.setTimeOffForPeriod(response.markedGroupMembers);
          }
        })
        .catch((error) => console.error(error));
    },
  },
  computed: {
    ...mapGetters("reportStore", [
      "timeOffForPeriodApiState",
      "timeOffForPeriod",
    ]),
    loading() {
      return this.timeOffForPeriodApiState === APISTATE.LOADING;
    },
    validated() {
      return this.dateFrom && this.dateTo && this.groupId;
    },
    filteredData() {
      return this.timeOffForPeriod;
    },
  },
};
</script>
